/* @sravni/react-design-system version 0.2.65 */
import { __read } from 'tslib';
import React__default from 'react';
import { useStyles, safeInvoke } from '@sravni/react-utils';
import { Warning, File, Trash } from '@sravni/react-icons';
import '../../Space/index.js';
import '../../Icon/index.js';
import '../../Typography/index.js';
import '../../Progress/index.js';
import modules_64347241 from '../styles/Uploader.module.less.js';
import Icon from '../../Icon/src/Icon.js';
import Space from '../../Space/src/Space.js';
import { Text } from '../../Typography/src/Text.js';
import Progress from '../../Progress/src/Progress.js';

/**
 * @description Uploader component.
 *
 * @component
 * @example
 * ```jsx
 * <Uploader.Item key={fileKey} file={file}/>
 * ```
 */
var UploaderItem = React__default.forwardRef(function (props, ref) {
    var file = props.file, progressPercent = props.progressPercent, errorMessage = props.errorMessage, onRemove = props.onRemove;
    var _a = __read(React__default.useState(''), 2), preview = _a[0], setPreview = _a[1];
    var cx = useStyles(modules_64347241);
    var classNames = cx('uploaderItem', {
        error: errorMessage,
    });
    var textSpace = progressPercent ? 8 : 2;
    var fileIcon = React__default.useMemo(function () {
        if (errorMessage) {
            return (React__default.createElement(Icon, { size: 20 },
                React__default.createElement(Warning, null)));
        }
        if (preview) {
            return React__default.createElement("img", { className: cx('filePreview'), src: preview, alt: "preview" });
        }
        return (React__default.createElement(Icon, { className: cx('fileIcon'), size: 20, shape: "round" },
            React__default.createElement(File, null)));
    }, [preview, errorMessage]);
    var handleRemove = React__default.useCallback(function () {
        safeInvoke(onRemove, file);
    }, [onRemove]);
    React__default.useEffect(function () {
        if (!file.type.match('image/*')) {
            setPreview('');
        }
        else {
            var reader_1 = new FileReader();
            reader_1.readAsDataURL(file);
            reader_1.onloadend = function () { return reader_1.result && setPreview(reader_1.result.toString()); };
        }
    }, [file]);
    return (React__default.createElement(Space, { ref: ref, "data-qa": "UploaderItem", size: 12, align: "center", className: cx(classNames) },
        fileIcon,
        React__default.createElement(Space, { size: textSpace, direction: "vertical", className: cx('textContainer') },
            React__default.createElement(Text, { size: 16, strong: true, truncate: true }, file.name),
            progressPercent && React__default.createElement(Progress, { percent: progressPercent }),
            errorMessage && React__default.createElement(Text, { size: 12 }, errorMessage)),
        !errorMessage && React__default.createElement(Icon, { size: 20, icon: React__default.createElement(Trash, null), className: cx('removeIcon'), onClick: handleRemove })));
});
UploaderItem.displayName = 'UploaderItem';

export default UploaderItem;
//# sourceMappingURL=UploaderItem.js.map
